import { render } from "./Embeddings.vue?vue&type=template&id=dc8d8692&scoped=true&ts=true"
import script from "./Embeddings.vue?vue&type=script&lang=ts"
export * from "./Embeddings.vue?vue&type=script&lang=ts"

import "./Embeddings.vue?vue&type=style&index=0&id=dc8d8692&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc8d8692"]])

export default __exports__